import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_URL_API_UPLOAD,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
    },
    timeout: process.env.REACT_APP_TIMEOUT_API,
});

instance.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        // if (error.response && error.response.status === 401) {
        //     localStorage.removeItem('persist:root');
        //     window.location.reload();
        // }
        return error.response.data;
    }
);

export default instance;
